import { FeatureItem } from "../ui/FeatureItem";
import { Icon } from "../ui/Icon";
import { ProductShowcase } from "./ProductShowcase";

const features = [
  ["layers", "Visitor and contractor management"],
  ["qr", "QR invitations"],
  ["id", "Identity verification"],
  ["badge", "Badge printing"],
  ["flow", "Approval workflows"],
  ["bell", "Host notifications"],
  ["alert", "Emergency muster"],
  ["sites", "Multi-site management"],
];

export function OperationsSection() {
  return (
    <section id="overview" className="scroll-mt-20 bg-[#f6f8fb] px-5 py-16">
      <div className="mx-auto grid max-w-7xl items-center gap-12 lg:grid-cols-2">
        <div>
          <p className="text-sm font-bold tracking-[0.16em] text-brand-blue">BUILT FOR OPERATIONS</p>
          <h2 className="mt-3 text-3xl font-bold leading-tight md:text-4xl">Everything you need at the reception desk and beyond</h2>
          <p className="mt-4 text-slate-600">GLOBOVMS helps security teams, receptionists, and facility managers run visitor and contractor visits with an auditable record of who is on site.</p>
          <div className="mt-6 grid sm:grid-cols-2">
            {features.map(([icon, label]) => (
              <FeatureItem key={label} icon={<Icon name={icon} className="h-4 w-4" />}>{label}</FeatureItem>
            ))}
          </div>
        </div>
        <ProductShowcase />
      </div>
    </section>
  );
}
